export default __webpack_public_path__ + "static/media/gallery_02.ac44e9a9.jpg";